
<script>
import BaseEdit from './baseEdit/Edit'

export default {
  mixins: [
    BaseEdit
  ],
  data () {
    return {
      events: null,
      headerTitle: { title: 'Stany procesu', description: 'Tryb edycji' },
      service: this.$route.meta.acl.service,
      loginModalBackUrlName: ''
    }
  },
  created () {
    this.getInitEvents()
    this.getInitLoginModalBackUrlName()
  },
  methods: {
    getInitEvents () {
      this.events = {
        stateSubmit: `${this.service}:main:stateSubmit`
      }
    },
    getInitLoginModalBackUrlName () {
      this.loginModalBackUrlName = `${this.service}_1_state_listing`
    }
  }
}
</script>
